import type {GuessStatus} from '../ContentBlocks/GuessCorrectnessBanner';

// No translation header text
export const notAvailableText = 'Traducción no disponible';
export const answerInEnglishText =
  'Escribe tus respuestas en inglés de acuerdo con las instrucciones de la pregunta.';
export const btnDisabledWarning =
  'Las traducciones al español deben estar "desactivadas" para poder responder a esta pregunta.';

// Student Assignment View text
export const instructions = 'Instrucciones';
export const answerOptions = 'Opciones de respuesta';

export const eliminationToolText = 'Herramienta de eliminación';
export const hideEliminatedAnswersText = 'Ocultar respuestas eliminadas';
export const showEliminatedAnswersText = 'Mostrar respuestas eliminadas';

const selectInstructions = 'Selecciona todas las que correspondan';
const selectOneInstructions = 'Selecciona una respuesta';
const freeResponseInstructions = 'Proporciona tu respuesta a continuación';
const freeEntryInstructions = 'Responda la siguiente pregunta:';
const dropdownInstructions = 'Selecciona las opciones de la lista';
const passageCorrectionInstructions =
  ' Haz clic en la(s) palabra(s) que quieras editar en la oración de abajo y escribe tus cambios';
const freeEntryInputInstructions = 'Escribe la respuesta aquí. Presta atención a la ortografía.';
const freeEntryMathInputInstructions =
  'Ingrese la respuesta aquí. No incluya espacios ni unidades.'; // TODO 'Enter answer here. Do not include spaces or units.'
const highlightInstructions = 'Resalte la(s) respuesta(s) a continuación';
export const translatedInstructions = {
  freeResponse: freeResponseInstructions,
  freeEntry: freeEntryInstructions,
  freeEntryInput: freeEntryInputInstructions,
  freeEntryMathInput: freeEntryMathInputInstructions,
  passageCorrection: passageCorrectionInstructions,
  highlight: highlightInstructions,
  selectMultiple: selectInstructions,
  selectOne: selectOneInstructions,
  dropdown: dropdownInstructions
} as const;

export const Explanation = 'Explicación';
export const SampleResponse = 'Respuesta de muestra';
export const CorrectAnswers = 'Respuesta(s) Correcta(s)';
export const showPassage = 'Mostrar Pasaje';
export const hidePassage = `Ocultar Pasaje`;

export const graphing = {
  // types
  point: 'punto',
  line: 'línea',
  segment: 'segmento',
  ray: 'rayo',
  polygon: 'polígono',
  circle: 'círculo',
  inequality: 'desigualdad',
  parabola: 'parábola',
  // instructions
  cancel: 'Cancelar',
  delete: 'Eliminar',
  done: 'Edición terminada',
  add: 'Agregar',
  inclusive: 'inclusivo',
  exclusive: 'exclusivo',
  toggle: 'Alternar área sombreada',
  reverse: 'Dirección inversa',
  instructions: {
    circle: 'Coloque un segundo punto para definir el radio.',
    inequality: `Completa la desigualdad colocando un segundo punto.`,
    line: `Completa la línea colocando un segundo punto.`,
    parabola: `Completa la parábola colocando un segundo punto.`,
    point: `Trace un punto en el gráfico siguiente.`,
    polygon: `Coloque todos los vértices y luego cierre la forma seleccionando el primer punto.`,
    ray: `Completa el rayo colocando un segundo punto.`,
    segment: `Completa el segmento colocando un segundo punto.`
  }
} as const;

// written submissions

export const studentText =
  ' Se ha enviado tu respuesta y será calificada con otra aplicación fuera del sistema de Albert.';

export const pendingTeacherGradingText =
  'Tu respuesta fue enviada y tu profesor la está calificando. Vuelve más tarde para ver tu calificación.';

export const addMediaText = {
  button: 'Agregar medios',
  image: 'Imagen',
  audio: 'Audio'
};

export const fontDropdownText = {
  body: 'Contenido',
  heading: 'Título',
  'heading-one': 'Encabezado',
  'heading-two': 'Subtítulo'
};

export const saved = 'Guardado';
export const lastSaved = 'Última edición hace un momento';

export const time = {
  minute: 'minuto(s)',
  hour: 'hora(s)',
  day: 'dia(s)'
};

export const draftGuess = {
  pluralTimeUnits: ['días', 'horas', 'minutos'],
  timeUnits: ['un dia', 'una hora', 'un minuto'],
  offline: 'Sin conexión de red.',
  saveError: 'Se produjo un error al guardar el borrador.',
  loadError: 'Hubo un error al cargar tu borrador.',
  saving: 'Ahorro',
  default: 'Tu trabajo se guardará automáticamente'
};

export const guessCorrectnessBanner = new Map<GuessStatus, string>([
  ['unsubmitted', 'No se entregó una respuesta para esta pregunta.'],
  ['incorrect', 'Incorrecto'],
  ['partiallyCorrect', 'Has recibido crédito parcial'],
  ['correct', 'Correcto']
]);
